export default [
  {
    path: 'hosts',
    name: 'my/hosts',
    component: () => import('@/views/my/Hosts.vue'),
    meta: { title: '我的网站云' },
  },
  {
    path: 'templates',
    name: 'my/templates',
    component: () => import('@/views/my/Templates.vue'),
    meta: { title: '我的模板' },
  },
  {
    path: 'plugins',
    name: 'my/plugins',
    component: () => import('@/views/my/Plugins.vue'),
    meta: { title: '我的插件' },
  },
  {
    path: 'orders',
    name: 'my/orders',
    component: () => import('@/views/my/Orders.vue'),
    meta: { title: '订单管理' },
  },
  {
    path: 'invoices',
    name: 'my/invoices',
    component: () => import('@/views/my/Invoices.vue'),
    meta: { title: '发票管理' },
  },
  {
    path: 'serviceCodes',
    name: 'my/serviceCodes',
    component: () => import('@/views/my/ServiceCodes.vue'),
    meta: { title: 'ICP备案服务码' },
  },
  {
    path: 'tickets',
    name: 'my/tickets',
    component: () => import('@/views/my/Tickets.vue'),
    meta: { title: '我的工单' },
  },
  {
    path: 'tickets/:ticketNo',
    name: 'my/ticketMessages',
    component: () => import('@/views/my/TicketMessages.vue'),
    meta: { title: '工单详情' },
  },
  {
    path: 'create/:resource',
    name: 'my/create',
    component: () => import('@/views/my/Create.vue'),
    meta: { title: '一键部署' },
  },
];
